import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

interface PageHeroProps {
  label: string;
  title: string;
  subtitle?: string;
  bgImage: string;
}

export default function PageHero({ label, title, subtitle, bgImage }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden flex flex-col" style={{ minHeight: 500 }}>
      <img
        src={bgImage}
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/70 to-navy/85" />
      <div
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle, #c9a84c 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      {/* Navbar boşluğu */}
      <div className="h-[123px] shrink-0" />

      {/* İçerik — kalan alanda dikey ortalı */}
      <div className="relative flex-1 flex items-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12">

          {/* Breadcrumb */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-2 text-white/40 text-xs font-medium mb-6"
          >
            <Link to="/" className="hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gold">{label}</span>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.08 }}
            className="text-gold text-[11px] font-bold uppercase tracking-[0.28em] mb-4"
          >
            {label}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-5xl md:text-7xl font-extrabold text-white tracking-tight leading-[1.02] mb-5"
          >
            {title}
          </motion.h1>

          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="text-white/80 text-[15px] max-w-xl leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
